export default "__VITE_ASSET__ca8779a3__"